<template>
    <div>
        <div class="container">
            <div class="gr-12 gr-4@lg">
                <h2 class="heading">Let's create things together.</h2>

                <div class="wysiwyg">
                    <p>Dizajn i vizualizacija d.o.o. </p>
                    <p>Čret 28 </p>
                    <p>10 000 Zagreb </p>
                    <p>Croatia </p>
                    <p><strong><a href="mailto:ivica@dizviz.hr">ivica@dizviz.hr</a></strong></p>
                    <p>tel. <strong><a href="tel:+385/91/5977043">+385/91/5977043</a></strong></p>
                    <p>OIB: 44645609177 </p>
                    <p>IBAN: HR902484008­1104610382</p>
                    <br>                
                    <br>                
                    <p><strong><a href="#">Facebook</a></strong></p> 
                    <p><strong><a href="#">Linkedin</a></strong></p>
                </div>

            </div>

            <div class="gr-12 gr-6@lg push-2@lg">
                <form action="" id="form-contact" class="form" @submit.prevent="onSubmit">
                    <fieldset class="form__fieldset">
                        <label for="name" class="form__label">Name</label>
                        <input v-model="contact.name" type="text" name="name" class="form__textfield">
                    </fieldset>

                    <fieldset class="form__fieldset">
                        <label for="email" class="form__label">E-mail</label>
                        <input v-model="contact.email" type="text" name="email" class="form__textfield">
                    </fieldset>

                    <fieldset class="form__fieldset">
                        <label for="message" class="form__label">Message</label>
                        <textarea v-model="contact.message" type="text" name="message" class="form__textarea"></textarea>
                    </fieldset>

                    <div v-if="isSending" class="form__loading">Sendig... (not sending really... just testing...)</div>

                    <button class="btn">Send message</button>


                    <br>
                    <hr>
                    <p>Test output:</p>
                    <p><pre>{{ $data }}</pre></p>
                </form>
            </div>
        </div>

        <Prefooter />
        <Footer />
    </div>
</template>

<script>
// components
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue'


    export default {
        components: {
            Prefooter,
            Footer
        },
        data() {
            return {
                contact: {
                    name: '',
                    email: '',
                    message: '',
                },
                isSending: false
            }
        },
        methods: {
            // Clear the data in form
            clearForm() {
                for (let field in this.contact) {
                    this.contact[field] = ''
                }
            },

            // Submit handler
            onSubmit(evt) {
                evt.preventDefault();

                this.isSending = true;

                // TODO send form data to server and submit
            }
        }
    };
</script>


<style scoped lang="scss">
    
</style>